import { getStorage } from './cache';

/**
 * @description 获取预请求内容
 * @function getPreFetchData
 * @param {Object} options - 选项
 * @param {string} options.preFetchName - 预请求名称
 * @param {Function} options.requestMethod - 接口请求方法
 * @param {string} options.cacheKey - 缓存键名
 * @returns {Promise<{isPreFetch: boolean, result: any}>} 返回promise对象
 */
export async function getPreFetchData(options) {
  const {
    preFetchName = '',
    requestMethod = null,
    cacheKey = '',
  } = options || {};
  const startTime = performance.now();

  // 1.获取预请求内容
  if (preFetchName && window[preFetchName]) {
    try {
      const { success, result } = await window[preFetchName] || {};
      const duration = performance.now() - startTime;
      // 清除预取数据
      delete window[preFetchName];

      if (success && result) {
        // eslint-disable-next-line no-console
        console.log(
          `[getPreFetchData => ${preFetchName}] 预请求内容获取成功，耗时: ${duration.toFixed(
            2,
          )}ms`,
        );
        return { isPreFetch: true, isCache: false, result };
      }

      // eslint-disable-next-line no-console
      console.log(
        `[getPreFetchData => ${preFetchName}] 预请求内容获取失败，失败原因:`,
        result,
      );
    } catch (error) {
      // 清除预取数据
      delete window[preFetchName];
      // eslint-disable-next-line no-console
      console.warn(
        `[getPreFetchData => ${preFetchName}] 预请求内容获取失败`,
        error,
      );
    }
  }

  // 2.获取本地缓存内容
  if (cacheKey) {
    try {
      const result = getStorage(cacheKey);
      if (result) {
        const duration = performance.now() - startTime;
        // eslint-disable-next-line no-console
        console.log(
          `[getPreFetchData => ${cacheKey}] 本地缓存内容获取成功，耗时: ${duration.toFixed(
            2,
          )}ms`,
        );
        return { isPreFetch: false, isCache: true, result };
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        `[getPreFetchData => ${cacheKey}] 本地缓存内容获取失败`,
        error,
      );
    }
  }

  // 3.获取接口请求内容
  if (requestMethod && typeof requestMethod === 'function') {
    try {
      const result = await requestMethod();
      const duration = performance.now() - startTime;
      // eslint-disable-next-line no-console
      console.log(
        `[getPreFetchData => ${preFetchName}] 接口请求内容获取成功，耗时: ${duration.toFixed(
          2,
        )}ms`,
      );
      return { isPreFetch: false, isCache: false, result };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        `[getPreFetchData => ${preFetchName}] 接口请求内容获取失败`,
        error,
      );
    }
  }

  return { isPreFetch: false, isCache: false, result: null };
}

export default {};
